// cookie缓存key
export const COOKIE_JESSSION_ID_KEY = 'JSESSIONID'

// 是否从BO端登录过来的标识
export const SIMULATED_KEY = 'simulated'

// 续期前的页面路径
export const COOKIE_LOGIN_KEY = 'sso_cb'

// 多语言缓存key
export const LOCALE_KEY = 'stp-locale'

// 默认语言
export const DEFAULT_LOCALE_KEY = 'en-US'

// token
export const TOKEN_KEY = 'token'

// 多语言store key
export const LOCALE_STORE_KEY = 'stp-locale-message'

// 多语言切换开关（sessionStorage）
export const LOCALE_SWITCH_SESSION_KEY = 'stp-locale-switch-enabled'

// stp公告阅读状态
export const NOTICE_READ_STATUS = 'stp-notice-read-status'

// 当前月佣金id
export const COMMISSION_CURRENT_MONTH_ID = 'commission-current-month-id'

// 登录失败重试次数
export const LOGIN_FAILED_RETRY_COUNT = 'login-failed-retry-count'

// 异常已读标志
export const EXCEPTION_READ_STATUS = 'exception-read-status'
